import { getBodyElement } from "../../../exports/dom";
import { onInit } from "../../../exports/tracking";
import { instrument } from "../../../exports/apm";
import { loggerScope } from "../parser/utils.js";
import { getTrackableElements } from "../parser/elements.js";
import { withInitLock } from "./defer.js";
import { registerTrackingHandler, unregisterTrackingHandler } from "./register.js";

const log = loggerScope.scope("init");

/*                                                                    */
export const observer = new MutationObserver((mutations) => {
  mutations
    .filter((m) => m.type === "childList")
    .forEach((mutation) => {
      const elementsToTrack = getTrackableElements(mutation.addedNodes);
      elementsToTrack.forEach((e) => withInitLock(e, registerTrackingHandler));

      const removedElements = getTrackableElements(mutation.removedNodes);
      removedElements.forEach(unregisterTrackingHandler);
    });
});

/**
 *
 *
 *
 *
 *
 */
export const initDataTracker = instrument(
  async function (this): Promise<void> {
    log.info("Initialize tracking system");

    /*                                            */
    /*                                                  */
    /*                          */
    await Promise.race([
      new Promise<void>((r) => setTimeout(r, 1000)),
      new Promise<void>((r) => onInit.sub(r, { once: true })),
    ]);

    log.info("Bootstrap tracking system");
    /*                                                           */
    /*                                                             */
    const theBody = getBodyElement();
    const elementsToTrack = getTrackableElements([theBody]);

    log.info("Registering elements for tracking", elementsToTrack.length);
    elementsToTrack.forEach((e) => withInitLock(e, registerTrackingHandler));

    /*                                            */
    this?.addLabels({ gr_tracking_element_count: elementsToTrack.length });

    log.info("initialize MutationObserver for tracking");
    observer.observe(theBody, { childList: true, subtree: true });
  },
  "Init Tracking Wrapper",
  "module-init.global-resources.tracking",
);
